export default "__VITE_ASSET__Cs5i9KVm__"